import { useFragment } from '@frameio/graphql-client';
import { PaymentMethodSubscription } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { getIsBillingCountryVatExemptEligible } from '../utils';
import { useGetBillingCountry } from './useGetBillingCountry';

/**
 * util used to check if their is a possible VAT id validation problem.
 * This is based under the assumption that a VAT id is present but the tax
 * is still being reflected
 */
export function useMaybeHasErrorValidatingVat(tax: number) {
  const accountId = useActiveAccountId() ?? '';
  const billingCountry = useGetBillingCountry();

  const { data } = useFragment({
    fragment: PaymentMethodSubscription,
    fragmentName: 'PaymentMethodSubscription',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  const paymentMethod = data?.subscription?.paymentMethod;
  const isPaymentMethodCard = paymentMethod?.__typename === 'PaymentCard';

  const hasExistingTaxId = isPaymentMethodCard ? !!paymentMethod?.taxId : false;

  const isBillingCountryVatExemptEligible = billingCountry
    ? getIsBillingCountryVatExemptEligible(billingCountry)
    : false;
  const hasTaxIncluded = tax > 0;

  return (
    isBillingCountryVatExemptEligible && hasTaxIncluded && hasExistingTaxId
  );
}
